import { Component, Input } from '@angular/core';

const STEP_VALUE_CONSTANT = 33;

@Component({
  selector: 'app-progreso',
  templateUrl: './progreso.component.html',
  styleUrls: ['./progreso.component.css'],
})
export class ProgresoComponent {
  @Input() progressValue: number;

  constructor() {}

  public isActive(stepValue: number): boolean {
    return this.progressValue >= stepValue && this.progressValue < stepValue + STEP_VALUE_CONSTANT;
  }

  public isVisible(stepValue: number): boolean {
    return (
      this.progressValue >= stepValue - STEP_VALUE_CONSTANT && this.progressValue <= stepValue + STEP_VALUE_CONSTANT
    );
  }
}
